// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"92":"ec03f98a","124":"40fc91f2","170":"b47dcd0d","204":"1b5ea505","298":"86d57e46","464":"2f25db7e","609":"9afb4879","626":"beff5bb5","990":"4f0559f4"}[chunkId] + ".chunk.js";
};